"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DROPDOWN_LABEL_CONTENT = exports.DROPDOWN_LABEL = exports.DROPDOWN_VALUE = exports.DROPDOWN_OPTION = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var DROPDOWN_BORDER_SIZE = 2,
    sharedOptionProps = function sharedOptionProps(a) {
  var b = a.height;
  return {
    height: "".concat((b || 50) - DROPDOWN_BORDER_SIZE, "px"),
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-start",
    boxSizing: "border-box"
  };
},
    DROPDOWN_OPTION = function DROPDOWN_OPTION(a) {
  var b = a.hideSeparators,
      c = a.height;
  return (0, _cxs["default"])(_objectSpread({}, sharedOptionProps({
    height: c
  }), {
    paddingLeft: "15px",
    paddingRight: "15px",
    cursor: "pointer",
    "&:not(:last-child)": {
      borderBottom: b ? void 0 : "1px solid ".concat(_vars.COLOURS.grey.mischka.russian)
    },
    ":hover": {
      background: _vars.COLOURS.grey.catSkillWhite
    }
  }));
};

exports.DROPDOWN_OPTION = DROPDOWN_OPTION;

var DROPDOWN_VALUE = function DROPDOWN_VALUE(a) {
  var b = a.height;
  return (0, _cxs["default"])(_objectSpread({}, sharedOptionProps({
    height: b
  })));
};

exports.DROPDOWN_VALUE = DROPDOWN_VALUE;

var DROPDOWN_LABEL = function DROPDOWN_LABEL(a) {
  return (0, _cxs["default"])({
    display: "flex",
    alignItems: "center",
    color: a ? _vars.FLATTENED_COLOURS[a] : void 0,
    " >:first-child:not(:only-child)": {
      marginRight: "10px"
    }
  });
};

exports.DROPDOWN_LABEL = DROPDOWN_LABEL;

var DROPDOWN_LABEL_CONTENT = function DROPDOWN_LABEL_CONTENT(a) {
  var b = a.disabled,
      c = a.fontSize;
  return (0, _cxs["default"])({
    color: b ? _vars.COLOURS.grey.mischka.michael : _vars.COLOURS.mono.black,
    fontSize: c && "".concat(c, "px")
  });
};

exports.DROPDOWN_LABEL_CONTENT = DROPDOWN_LABEL_CONTENT;